import * as Redux from 'redux';
import { SimManagementError } from '../../models/Errors';
import {
  ENSURE_PROVISIONING_EXCLUDED_DAYS,
  LOAD_PROVISIONING_EXCLUDED_DAYS,
  LOAD_PROVISIONING_EXCLUDED_DAYS_FAILURE,
  LOAD_PROVISIONING_EXCLUDED_DAYS_PENDING,
  LOAD_PROVISIONING_EXCLUDED_DAYS_SUCCESS,
} from '../actionTypes';
import { Action, ActionMeta, RejectFunc, ResolveFunc } from '../commonActions';

export function ensureProvisioningExcludedDays(commandDefinitionIds: number[]): Action<number[]> {
  return {
    type: ENSURE_PROVISIONING_EXCLUDED_DAYS,
    payload: commandDefinitionIds,
  };
}

export function loadProvisioningExcludedDays(resolve?: ResolveFunc<string[]>, reject?: RejectFunc) {
  return {
    type: LOAD_PROVISIONING_EXCLUDED_DAYS,
    resolve,
    reject,
  };
}

export function loadProvisioningExcludedDaysPending(commandDefinitionIds: number[]): Action<number[]> {
  return {
    type: LOAD_PROVISIONING_EXCLUDED_DAYS_PENDING,
    payload: commandDefinitionIds,
  };
}

export function loadProvisioningExcludedDaysSuccess(
  commandDefinitionIds: number[],
  dates: string[],
): ActionMeta<string[], number[]> {
  return {
    type: LOAD_PROVISIONING_EXCLUDED_DAYS_SUCCESS,
    payload: dates,
    meta: commandDefinitionIds,
  };
}

export function loadProvisioningExcludedDaysFailure(payload: SimManagementError): Action<SimManagementError> {
  return {
    type: LOAD_PROVISIONING_EXCLUDED_DAYS_FAILURE,
    payload,
  };
}
